/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const Service: core.serialization.ObjectSchema<serializers.Service.Raw, Truvity.Service> =
    core.serialization.object({
        id: core.serialization.string(),
        serviceEndpoint: core.serialization.string(),
        type: core.serialization.string(),
    });

export declare namespace Service {
    export interface Raw {
        id: string;
        serviceEndpoint: string;
        type: string;
    }
}
